import { render, staticRenderFns } from "./ScreenDevicesLocations.vue?vue&type=template&id=8b97c3d0&scoped=true&"
import script from "./ScreenDevicesLocations.vue?vue&type=script&lang=js&"
export * from "./ScreenDevicesLocations.vue?vue&type=script&lang=js&"
import style0 from "./ScreenDevicesLocations.vue?vue&type=style&index=0&id=8b97c3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b97c3d0",
  null
  
)

export default component.exports